import lodashCompact from 'lodash/fp/compact';
import { anonymousUtilityUser } from 'client/constants';

import { SR_API_ACTION_UTILITY_PARTNER_SIGNUP } from 'api/utilityActionTypes';

import { hasRolePartner, hasRoleAnonymous } from 'common/utility/userRoles';

import loadCurrentUtilityPartnerAction from 'client/actions/UtilityPartner/loadCurrentUtilityPartner';

export async function onLogicSuccess({ state, utilityApiClient, user }) {
  const currentUser = { ...anonymousUtilityUser, ...user };

  await Promise.all(
    lodashCompact([
      hasRolePartner(user.roles) &&
        user.utilityPartnerId &&
        loadCurrentUtilityPartnerAction(
          { state, utilityApiClient },
          {
            id: user.utilityPartnerId,
            // `loadCurrentUtilityPartner` returns whatever is already in the tree unless it
            // is forced, so a `currentPartner` left over from an earlier partner in this same
            // SPA session would survive while `utilityUser` moved on. Everything downstream
            // authorizes against `currentPartner` — `UtilityPartnerOverviewPage` compares it
            // to the partner in the URL — so a stale one locks the new partner out of their
            // own page. Whoever just authenticated is the current partner, by definition.
            forceRefresh: true,
          },
        ),
    ]),
  );

  state.set('utilityUser', currentUser);
}

export default async function partnerSignup({ state, history, utilityApiClient }, payload) {
  const utilityUser = state.get(['utilityUser']);

  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_SIGNUP,
    state: state,
    payload,
    async onSuccess({ partner, user }) {
      // An admin user is signing up a partner
      if (!hasRoleAnonymous(utilityUser.roles)) {
        history.replace(`/utility-profit/${partner.slug}`);
        return;
      }

      await onLogicSuccess({
        state,
        utilityApiClient,
        user,
      });

      // Send the brand-new partner straight to their own page, the same as the admin path
      // above. Without this the signup page just stops matching its own guards and falls
      // through to `getUserLandingPage`, which bounces through `/utility-profit` — an extra
      // page that redirects on its first render, so it unmounts mid-transition. It also
      // decides between the partner page and `/logout` purely on whether `currentPartner`
      // happens to be in the tree yet. We know the slug here, so don't leave it to chance.
      history.replace(`/utility-profit/${partner.slug}`);
    },
  });
}
